<template>
  <div class="app-container">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="分类名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="上级分类" prop="top_id">
            <!-- <el-tag>+</el-tag> -->
            <el-col :span="24">
              <!-- <el-button @click="cousebox=true">选择关联</el-button> -->
              <el-cascader
                v-model="selOption"
                placeholder="默认顶级"
                :options="options"
                :props="{
                  checkStrictly: true,
                  label: 'name',
                  value: 'id',
                }"
                clearable
                @change="changeOption"
              ></el-cascader>
            </el-col>
            <el-col :span="24"
              >当前：
              <span>{{ selTop.top_name }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="显示" prop="is_show">
            <el-radio-group v-model="ruleForm.is_show">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="置顶" prop="top">
            <el-radio-group v-model="ruleForm.top">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-col :span="24">
              <el-input v-model="ruleForm.sort" placeholder="请输入数字，可不填" type="number"></el-input>
            </el-col>
            <el-col :span="24">
              <span>默认1000,越大越靠前</span>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>
    <el-dialog title="课程列表" :visible.sync="cousebox">
      <div class="search-bar">
        <el-input v-model="keyword_search" placeholder="输入关键字查询" clearable @clear="paperCateList"></el-input>
        <el-button type="primary" @click="paperCateList">查询</el-button>
        <el-button type="primary" @click="resetCouse">重置</el-button>
      </div>

      <el-table
        ref="multipleTable"
        highlight-current-row
        :data="couseList"
        height="50vh"
        @current-change="handleCchange"
      >
        <!-- <el-table-column
                    type="selection"
                    width="55"
                >
                </el-table-column> -->
        <el-table-column property="title" label="名称" width="200"></el-table-column>
        <el-table-column property="address" label="封面">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.cover"
              fit="contain"
              :preview-src-list="[scope.row.cover]"
            >
            </el-image>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[5, 10, 20, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <div style="text-align: center">
        <el-button @click="cousebox = false">确定</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
          <el-table :data="gridData">
            <el-table-column property="date" label="日期" width="150"></el-table-column>
            <el-table-column property="name" label="姓名" width="200"></el-table-column>
            <el-table-column property="address" label="地址"></el-table-column>
          </el-table>
        </el-dialog> -->
  </div>
</template>

<script>
import imgUpload from "@/components/pub/imgUploadNormal.vue";
import imgUploads from "@/components/pub/supperUpload.vue";
import fullEdit from "@/components/pub/fulledit.vue";
import { addPaperCate, editPaperCate, paperCateDetail, paperCateList } from "@/api/edu.js";
import { getTeacherList } from "@/api/teacher.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  components: {
    imgUpload,
    imgUploads,
    fullEdit,
  },
  mixins: [mixin],
  data() {
    return {
      options: [],
      keyword_search: "",
      page_size: 5,
      cousebox: false,
      tableData: [],
      dates: [],
      loading: false,
      typeList: [],
      couseList: [],
      ruleForm: {
        id: this.$route.query.id ? this.$route.query.id : 0,
        top_id: "",
        is_show: 1,
        top: 0,
      },
      couseSelect: this.$route.query.cate || {},
      rules: {
        name: [
          {
            required: true,
            message: "请输入分类名称",
            trigger: "blur",
          },
        ],
      },
      option: [],
      selOption: "",
      selTop: { top_name: "" },
    };
  },
  mounted() {
    const row = this.$route.query;
    console.log(row);
    if (row.tid) {
      this.selTop = row;
      this.selOption = row.tid;
      console.log("有上级ID");
      var path = row.top_path;
      var arr = path.split("-");
      console.log(arr);
      const length = arr.length;
      const tmpArr = [];
      arr.forEach((item, index) => {
        if (index > 0 && index < length) {
          tmpArr.push(item);
        }
      });
    } else {
      console.log("无上级ID");

      if (row.id) {
        console.log("编辑");
        this.getDetail(row);
      }
    }
    this.$forceUpdate();

    this.paperCateList("");
  },
  methods: {
    changeOption(e) {
      console.log(e);
      // console.log(e.length)
      this.option = e;
    },
    resetCouse() {
      this.keyword_search = "";
      this.page_index = 1;
      this.paperCateList();
    },
    handleCchange(val) {
      console.log(val);
      this.options = val;
    },
    async getDetail(row) {
      const res = await paperCateDetail(row.id);
      const self = this;
      if (res) {
        console.log(res);
        self.ruleForm = res;
        self.$forceUpdate();
        // if (res.cate instanceof Array) {
        //     res.cate_uuid = res.cate.map(it => {
        //         return it.uuid
        //     })
        // }
        // if (res.banner) {
        //     if (!Array.isArray(res.banner)) {
        //         res.banner = JSON.parse(res.banner)
        //     }
        // }
        this.ruleForm = {
          ...res,
        };
        console.log(res);
      }
    },
    getType() {
      getLiveType().then((res) => {
        console.log(res);
        if (res.data instanceof Array) {
          this.typeList = res.data;
        }
      });
    },
    getList() {
      this.paperCateList();
    },
    paperCateList() {
      paperCateList({
        keyword_search: this.keyword_search,
        page_index: this.page_index,
        page_size: this.page_size,
      }).then((res) => {
        if (res.data instanceof Array) {
          this.options = res.data;
          this.total = res.total;
        }
      });
    },
    editPaperCate(data, uuid) {
      editPaperCate(data, uuid).then((res) => {
        console.log(res);
        if (res) {
          this.$message.success("编辑成功");

          this.$router.go(-1);
        }
      });
    },
    addPaperCate(data) {
      addPaperCate(data).then((res) => {
        console.log(res);
        if (res) {
          this.$message.success("新增成功");

          this.$router.go(-1);
        }
      });
    },
    submitForm(formName) {
      const optionArr = [];
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            ...this.ruleForm,
            option: this.options.join("-"),
          };
          if (this.ruleForm.id) {
            this.editPaperCate(data, this.ruleForm.id);
          } else {
            this.addPaperCate(data);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.option {
  display: flex;

  & > span {
    width: 50%;
  }
}
</style>
